import { Injectable } from '@angular/core';
import { ListRoutingInstructionsByScheduleLegRqst, ReferenceApiService, RoutingInstructions } from '@xpo-ltl/sdk-reference';
import { BaseCacheService } from 'app/utils/angular-utils/services';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';

interface RoutingInstructionsCacheParams {
  origSicCd: string;
  destSicCd: string;
  drivingLegId?: string;
}

@Injectable()
export class RoutingInstructionsCacheService extends BaseCacheService<RoutingInstructionsCacheParams, RoutingInstructions[]> {
  constructor(private referenceService: ReferenceApiService) {
    super();
  }

  public request(params: RoutingInstructionsCacheParams): Observable<RoutingInstructions[]> {
    return super.request(params).pipe(map(routes => (params.drivingLegId ? _.filter(routes, (route: RoutingInstructions) => route.drivingLegId === params.drivingLegId) : routes)));
  }

  protected getKeyFromParams(params: RoutingInstructionsCacheParams): string {
    return `${_.defaultTo(params.origSicCd, '').toUpperCase()},${_.defaultTo(params.destSicCd, '').toUpperCase()}`;
  }

  protected requestData(params: RoutingInstructionsCacheParams): Observable<RoutingInstructions[]> {
    const request = new ListRoutingInstructionsByScheduleLegRqst();
    request.origSicCd = _.defaultTo(params.origSicCd, '').toUpperCase();
    request.destSicCd = _.defaultTo(params.destSicCd, '').toUpperCase();
    return this.referenceService.listRoutingInstructionsByScheduleLeg(request, { toastOnError: false }).pipe(pluck('routingInstructions'));
  }
}
